export type JobManagementStats = {
   active: number;
   archived: number;
};

export type JobsBrowserPaginationMeta = {
   current_page: number;
   last_page: number;
   per_page: number;
   total: number;
   from: number;
   to: number;
};

export type JobManagementItem = {
   id: number;
   user_type: string;
   role: string;
   first_name?: string;
   last_name?: string;
   full_name: string;
   active_jobs?: number;
   archived_jobs?: number;
   jobs_count: number;
   jobs_stats: JobManagementStats;
};

export type JobManagementMeta = JobsBrowserPaginationMeta;

export type JobManagementResponse = {
   data: JobManagementItem[];
   meta: JobManagementMeta;
   message: string;
   status: number;
};

export type JobsBrowserSort = 'date' | 'apply';

export const JobsBrowserStatus = {
   ACTIVE: 1,
   ARCHIVED: 0,
} as const;

export type JobsBrowserStatus = (typeof JobsBrowserStatus)[keyof typeof JobsBrowserStatus];

export type JobsBrowserActionResponse = {
   message: string;
   status: number;
};

export type JobsBrowserPlan = {
   id: number;
   plan_name: string;
   feature_ids: string;
   amount: number;
   type: string;
   type_value: number;
   status: number;
   created: string;
   slug: string;
   fvalues: string;
   planuser: string;
   applie_plan_id: number | null;
};

export type JobsBrowserUserPlan = {
   id: number;
   invoice_no: number;
   payment_id: number;
   user_id: number;
   plan_id: number;
   features_ids: string;
   fvalues: string;
   amount: number;
   status: number;
   pid: number | null;
   payment_url: string | null;
   pay_info: string | null;
   pdf_token: string | null;
   payer: string | null;
   type: string;
   type_value: number;
   start_date: string;
   end_date: string;
   created: string;
   slug: string;
   is_expire: number;
   plan: JobsBrowserPlan;
};

export type JobsBrowserJob = {
   id: number;
   user_plan_id: number;
   job_id: number;
   job_number: string;
   user_id: number;
   admin_id: number;
   type: string;
   title: string;
   category_id: number;
   subcategory_id: string;
   category_id_2: number | null;
   subcategory_id_2: string | null;
   category_id_3: number | null;
   subcategory_id_3: string | null;
   only_resume: number;
   questionary: number;
   skill: string;
   designation: string | null;
   location: string | null;
   job_city: string | null;
   price: number;
   price_status: number;
   role: string;
   description: string;
   company_name: string;
   work_type: number;
   contact_name: string | null;
   contact_number: string | null;
   contact_number_2: string | null;
   contact_number_3: string | null;
   contact_email: string | null;
   form_link: string | null;
   vacancy: number;
   address: string;
   state_id: number;
   city_id: number;
   postal_code: string;
   url: string;
   youtube_link: string;
   lastdate: string | null;
   slug: string;
   status: number;
   verify: number;
   job_status: number;
   created: string;
   modified: string;
   updates_count: number;
   last_update_at: string | null;
   payment_status: number;
   amount_paid: number;
   logo: string | null;
   expire_time: number;
   dis_amount: number | null;
   promo_code: string | null;
   selling_point1: string;
   selling_point2: string | null;
   selling_point3: string | null;
   hot_job_time: number;
   search_count: number;
   view_count: number;
   job_logo_check: number;
   invoice_inumber: number | null;
   payment_type: string | null;
   weekly_email_sent: number;
   exp_year: string;
   exp_month: string;
   min_exp: number;
   max_exp: number;
   salary_min: number;
   salary_max: number;
   salary_currency: number;
   confidential: string;
   job_position: string;
   eligibility: string;
   job_salary: string;
   job_experience_id: string;
   job_email: string;
   job_fax: string;
   designation_ofperson: string;
   brief_abtcomp: string;
   meta_tag_title: string | null;
   meta_tag_keywords: string | null;
   meta_tag_description: string | null;
   meta_tag_keyphrase: string | null;
   l_status: number;
   l_skill: number;
   l_exp: number;
   lat: string;
   long: string;
   feed_id: number | null;
   apply_url: string | null;
   lng_1: number;
   lng_skill_1: number;
   lng_2: number;
   lng_skill_2: number;
   user_plan: JobsBrowserUserPlan;
};

export type JobsBrowserListItem = {
   planDetails: string;
   Job: JobsBrowserJob;
   totalCandidate: number;
   newApplicationCount: number;
   jobAlert: number;
};

export type JobsBrowserListResponse = {
   data: JobsBrowserListItem[];
   meta: JobsBrowserPaginationMeta;
   message: string;
   status: number;
};
